var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"subtle-link",attrs:{"href":_vm.props.link,"target":"_blank"}},[_c('span',{staticClass:"subtle-link__text"},[_vm._t("default")],2),_c('Icon',{staticClass:"icon-arrow_right",attrs:{"size":"sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }